import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {SHARED_MAIN_VIEW_COMPONENT_WITH_MARGIN_STYLES} from 'analysis-tool/AnalysisToolConstants';
import getOutputFilesFromStep from 'analysis-tool/data/getOutputFilesFromStep';
import {assert} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import * as benchlingUtil from 'BenchlingUtil';
import BenchLink from 'link-preview/BenchLink';
import getTestProps from 'test/lib/cypress/getTestProps';
import {TooltipWrapper} from 'ui-library/bs/Tooltip';
import Button, {ButtonStyle, ButtonSize} from 'ui-library/buttons/Button';
import Pane from 'ui-library/pane/Pane';

import {AnalysisMainViewItemType, MainViewComponentProps} from '../MainViewTypes';
import ExternalFilePaneContent from './ExternalFilePaneContent';

export default function FileView({
  selectedItem: {fileId},
  step,
}: MainViewComponentProps<AnalysisMainViewItemType.FILE>): JSX.Element {
  const pipelineFile = getOutputFilesFromStep(step).find((file) => file.id === fileId);
  assert(pipelineFile != null, 'Expected specified fileId to be present in step output datas', {
    fileId,
    step,
  });
  assert(pipelineFile.externalFileId != null, 'Pipeline file has not been finalized', {fileId});

  return (
    <div className={css(styles.wrapper)} {...getTestProps({component: 'FileView', element: 'root'})}>
      <Pane
        title={pipelineFile.filename}
        toolbar={
          BenchlingConfig.FILES_ENABLE && (
            <TooltipWrapper tooltipTitle="Open file in new tab">
              <BenchLink href={benchlingUtil.pathToURL(pipelineFile.url)} fileId={pipelineFile.id}>
                <Button icon="open" buttonStyle={ButtonStyle.TERTIARY_GRAY} size={ButtonSize.MINI} />
              </BenchLink>
            </TooltipWrapper>
          )
        }
      >
        <ExternalFilePaneContent file={pipelineFile} />
      </Pane>
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    ...SHARED_MAIN_VIEW_COMPONENT_WITH_MARGIN_STYLES,
    height: '100%',
  },
});
